import { authorLinkIcon, authorLinkTitle } from '@/helpers/blog/author';
import arrowDownIcon from '@/assets/img/author/arrow-down.svg';

export default {
  name: 'AuthorHero',
  props: {
    author: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      arrowDownIcon
    };
  },
  methods: {
    linkIcon(type) {
      return authorLinkIcon(type);
    },
    linkTitle(link) {
      return authorLinkTitle(link);
    }
  }
};
